import { IconConfig } from "src/components/common/Icons/GenericIcon/IconConfig";
import { BcheckStatusEnum } from "./BcheckStatusEnum";
import { faHourglassStart, faCheckCircle, faTimesCircle, faSearch, faExclamationCircle, faClock, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import * as React from "react";
import { GenericIcon } from "src/components/common/Icons/GenericIcon/GenericIcon";


export function BcheckStatusIcon(props: { status: BcheckStatusEnum, showLabel?: boolean }) {
    const BCheckIcons: IconConfig<BcheckStatusEnum> = {
        ANALYZING: {
            icon: faHourglassStart,
            label: "Aguardando Resposta",
            className: "waiting"
        },
        APPROVED: {
            icon: faCheckCircle,
            label: "Aprovado",
            className: "success"
        },
        REJECTED: {
            icon: faTimesCircle,
            label: "Reprovado",
            className: "danger"
        },
        MANUAL_ANALYSIS: {
            icon: faSearch,
            label: "Análise Manual",
            className: "warning"
        },
        API_ERROR: {
            icon: faExclamationCircle,
            label: "Erro de API",
            className: "apiError"
        },
        CREATED: {
            icon: faClock,
            label: "Criado",
            className: "success"
        },
        UNDEFINED: {
            icon: faQuestionCircle,
            label: "Indefinido",
            className: "warning"
        },
    };

    return <GenericIcon showLabel={props.showLabel} iconConfig={BCheckIcons[props.status]} />;
}



// WEBPACK FOOTER //
// ./src/services/interfaces/Compliance/BcheckStatusIcon.tsx